module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-4_DE-60561c0e1acd63bc09de42a4664ef822.svg";